import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {IoniconsOutline} from "@pt/pt-models";
import {AppLinkBuilder} from '../../../../utils/app-link-builder';

@Component({
  selector: 'pt-widget-app-summary-row-app-v0',
  template: `
    <div class="pt-widget-app-summary-row-app-v0">
      <div class='application'>
        <pt-entity-icon [entity]='"applications"' [width]='30'></pt-entity-icon>
        <a class="name" href='{{appLink}}' target='_blank' *ngIf="appLink">
          {{ appName }}
          <pt-icon [key]='IconOpen' [size]='12'></pt-icon>
        </a>

        <div class="name" *ngIf="!appLink">
          {{ appName }}
          <pt-icon [key]='IconOpen' [size]='12'></pt-icon>
        </div>
      </div>

      <p *ngIf="requiredAlign">
        {{'WIDGET_WARNING.APP_SUMMARY_ALIGN' | translate}}
      </p>
    </div>

  `,
  styles: [`
    .pt-widget-app-summary-row-app-v0 {
      /*width: 200px;*/
      min-width: 200px;
      margin-right: 10px;
    }
    .application {
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      width: 200px;
      min-width: 200px;
    }

    .application pt-entity-icon {
      display: inline-flex;
      margin-right: 10px;
    }

    .application .name {
      display: inline-block;
      align-items: center;
    }

    .application .name pt-icon {
      display: inline-block;
    }
  `]
})
export class WidgetAppSummaryRowAppV0Component implements OnChanges {
  @Input() appId: number;
  @Input() appName: string;
  @Input() requiredAlign: boolean;

  @Output() alignValue = new EventEmitter<boolean>();

  public appLink?: string;
  public IconOpen = IoniconsOutline.open;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.appId) {
      this.appLink = AppLinkBuilder.linkOfEntity('applications', this.appId)
    } else {
      this.appLink = undefined;
    }

  }

}

